import { render, staticRenderFns } from "./OfficeListPhone.vue?vue&type=template&id=2a485995&"
import script from "./OfficeListPhone.vue?vue&type=script&lang=js&"
export * from "./OfficeListPhone.vue?vue&type=script&lang=js&"
import style0 from "./OfficeListPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports